import React, { useEffect, useState } from "react";
import axios from "axios";
import { Constant, imageDomain } from "../helper/Constants";

const AluminiSection = () => {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    loadTeams();
  }, []);

  const loadTeams = async () => {
    try {
      const res = await axios.get(Constant.getUrls.getAllAlumini);
      setTeams(res.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
      }}
    >
      {/* HEADER FROM FIRST SAMPLE */}
      {/* <p style={{ color: "#777", fontSize: "14px", marginBottom: "10px" }}>Our Team</p> */}

      <h1 style={{ fontSize: "38px", fontWeight: "700", marginBottom: "10px" }}>Our Alumini</h1>

      <h3 style={{ fontSize: "22px", marginBottom: "15px", color: "#3A3A3A" }}>
        Achivers. Toppers. Medalist.
      </h3>

      <p
        style={{
          color: "#666",
          fontSize: "16px",
          maxWidth: "700px",
          margin: "0 auto 50px",
          lineHeight: "24px",
        }}
      >
        We all their Hard word and dedication towards eduction with VASA they reached to their goals.
      </p>

      {/* TEAM GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "40px",
          justifyItems: "center",
        }}
      >
        {teams.map((member) => (
          <div key={member._id} className="teamCard">
            {/* IMAGE */}
            <img
              src={imageDomain + member.image}
              alt={member.name}
              className="teamImg"
            />

            {/* OVERLAY WITH NAME + POSITION */}
            <div className="teamOverlay">
              <h3>{member.name}</h3>
              <p>{member.achivements}</p>
            </div>
          </div>
        ))}
      </div>

      {/* GLOBAL WORKING CSS */}
     <style>{`
  .teamCard {
    width: 100%;
    max-width: 300px;
    height: 330px;
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .teamImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.4s ease;
  }

  /* OVERLAY — VISIBLE BY DEFAULT */
  .teamOverlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(41,22,110,0.9),
      rgba(41,22,110,0.4),
      rgba(255,255,255,0)
    );
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 40px;
    opacity: 1; /* 👈 always visible */
    transition: opacity 0.4s ease;
    color: white;
  }

  /* HOVER: REMOVE OVERLAY */
  .teamCard:hover .teamOverlay {
    opacity: 0;
  }

  /* IMAGE — NO DARK BY DEFAULT */
  .teamCard:hover .teamImg {
    transform: scale(1);
    filter: brightness(100%);
  }

  .teamOverlay h3 {
    margin: 0;
    font-size: 22px;
    font-weight: bold;
  }

  .teamOverlay p {
    margin: 5px 0 0 0;
    font-size: 16px;
  }
`}</style>

    </div>
  );
};

export default AluminiSection;
